/**
 * Справочник территорий: код НСИ → название.
 *
 * Эти же коды служат ключами dataRegion в моделях, поэтому список читает
 * генератор tools/build_rmg_model.py — держите его здесь, а не в разметке.
 */
export const REGIONS = [
    {code: "1100", title: "Российская Федерация"},
    {code: "1101", title: "Алтайский край"},
    {code: "1103", title: "Краснодарский край"},
    {code: "1104", title: "Красноярский край"},
    {code: "1105", title: "Приморский край"},
    {code: "1107", title: "Ставропольский край"},
    {code: "1108", title: "Хабаровский край"},
    {code: "1110", title: "Амурская область"},
    {code: "1112", title: "Астраханская область"},
    {code: "1114", title: "Белгородская область"},
    {code: "1115", title: "Брянская область"},
    {code: "1117", title: "Владимирская область"},
    {code: "1118", title: "Волгоградская область"},
    {code: "1119", title: "Вологодская область"},
    {code: "1120", title: "Воронежская область"},
    {code: "1122", title: "Нижегородская область"},
    {code: "1124", title: "Ивановская область"},
    {code: "1125", title: "Иркутская область"},
    {code: "1126", title: "Республика Ингушетия"},
    {code: "1128", title: "Тверская область"},
    {code: "1129", title: "Калужская область"},
    {code: "1130", title: "Камчатский край"},
    {code: "1132", title: "Кемеровская область"},
    {code: "1133", title: "Кировская область"},
    {code: "1134", title: "Костромская область"},
    {code: "1136", title: "Самарская область"},
    {code: "1137", title: "Курганская область"},
    {code: "1138", title: "Курская область"},
    {code: "1191", title: "Респ. Карачаево-Черкесия"},
    {code: "1140", title: "г. Санкт-Петербург"},
    {code: "1142", title: "Липецкая область"},
    {code: "1144", title: "Магаданская область"},
    {code: "1145", title: "г. Москва"},
    {code: "1146", title: "Московская область"},
    {code: "1147", title: "Мурманская область"},
    {code: "1149", title: "Новгородская область"},
    {code: "1150", title: "Новосибирская область"},
    {code: "1152", title: "Омская область"},
    {code: "1153", title: "Оренбургская область"},
    {code: "1154", title: "Орловская область"},
    {code: "1156", title: "Пензенская область"},
    {code: "1157", title: "Пермский край"},
    {code: "1158", title: "Псковская область"},
    {code: "1160", title: "Ростовская область"},
    {code: "1161", title: "Рязанская область"},
    {code: "1163", title: "Саратовская область"},
    {code: "1164", title: "Сахалинская область"},
    {code: "1165", title: "Свердловская область"},
    {code: "1166", title: "Смоленская область"},
    {code: "1168", title: "Тамбовская область"},
    {code: "1169", title: "Томская область"},
    {code: "1170", title: "Тульская область"},
    {code: "1171", title: "Тюменская обл.(б/а.о)"},
    {code: "171", title: "Ханты-Мансийский а.о."},
    {code: "271", title: "Ямало-Ненецкий а.о."},
    {code: "1173", title: "Ульяновская область"},
    {code: "1175", title: "Челябинская область"},
    {code: "1176", title: "Забайкальский край"},
    {code: "1177", title: "Чукотский авт.округ"},
    {code: "1178", title: "Ярославская область"},
    {code: "1179", title: "Республика Адыгея"},
    {code: "1180", title: "Республика Башкортостан"},
    {code: "1181", title: "Республика Бурятия"},
    {code: "1182", title: "Республика Дагестан"},
    {code: "1183", title: "Респ. Кабардино-Балкария"},
    {code: "1184", title: "Республика Алтай"},
    {code: "1186", title: "Республика Карелия"},
    {code: "1187", title: "Республика Коми"},
    {code: "1188", title: "Республика Марий Эл"},
    {code: "1189", title: "Республика Мордовия"},
    {code: "1190", title: "Респ. Северная Осетия"},
    {code: "1192", title: "Республика Татарстан"},
    {code: "1194", title: "Республика Удмуртия"},
    {code: "1195", title: "Республика Хакасия"},
    {code: "1196", title: "Республика Чечня"},
    {code: "1198", title: "Республика Саха (Якутия)"},
    {code: "1199", title: "Еврейская авт. обл."},
    {code: "1111", title: "Архангельская обл.(б/а.о)"},
    {code: "1127", title: "Калининградская область"},
    {code: "1141", title: "Ленинградская область"},
    {code: "1185", title: "Республика Калмыкия"},
    {code: "1193", title: "Республика Тыва"},
    {code: "1197", title: "Республика Чувашия"},
    {code: "971", title: "Ненецкий а.о."},
    {code: "1203", title: "Республика Крым"},
    {code: "1204", title: "Город Севастополь"},
]

export const regionTitle = code => REGIONS.find(item => item.code === code)?.title
